import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import { strings } from '../../resources/strings';
import ServicesContext from '../../contexts/ServicesContext';
import { Button } from '../../common-components/Button/Button';
import { CardNotificationV2 } from './CardNotificationV2/CardNotificationV2';
import { FooterContent } from './styles';
import { RecipeCollectionNotification } from '../../models/RecipeCollectionNotification';

interface IModalNotificationsProps {
  visible: boolean;
  close: (orderId?: number) => void;
  title: string;
  orderId?: number;
  orderNumber?: string;
  orderEmail?: string;
  orderPhone?: string;
}

const ModalNotificationsV2: React.FC<IModalNotificationsProps> = ({
  visible,
  close,
  title,
  orderId,
  orderNumber,
  orderEmail,
  orderPhone
}) => {

  const [notifications, setNotifications] = React.useState<RecipeCollectionNotification[]>([]);

  const {
    getRecipeCollectionNotificationsByOrderService,
    toastService
  } = React.useContext(ServicesContext);

  React.useEffect(() => {
    if (!visible) return;
    getNotifications();
  }, [visible]);

  const memoBody = React.useMemo(() => {
    if (!visible) return null;

    const orderHasAnyNotifications = notifications?.length > 0;

    if (!orderHasAnyNotifications) {
      return (
        <Alert variant='warning'>
          {strings.NoneNotificationFound}
        </Alert>
      );
    }

    return notifications.map(notification => {

      return (
        <CardNotificationV2
          key={`notification-${(notification.recipeNotificationResultId || 0) + (notification.internalCommunicationLogId || 0)}`}
          recipeNotification={notification}
        />
      );
    });
  }, [visible, notifications]);

  const memoFooter = React.useMemo(() => {
    if (!visible) return null;

    return (
      <>
        <Button text={strings.Update} width='190px' click={() => getNotifications()} />
      </>
    );
  }, [visible, notifications]);

  if (!visible) return null;

  return (
    <Modal
      size="lg"
      show={visible}
      onHide={() => clickCloseModal()}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton style={{ height: '50px' }}>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body id='modalRecipeBody' style={{ maxHeight: '78vh', overflowY: 'auto' }}>
        {memoBody}
      </Modal.Body>

      <Modal.Footer>
        <FooterContent>
          {memoFooter}
        </FooterContent>
      </Modal.Footer>
    </Modal>
  );

  function getNotifications() {
    if (!orderId) return;
    getRecipeCollectionNotificationsByOrderService
      .handle({ orderId: orderId }).then(result => {
        setNotifications(result?.value?.notifications || []);
      })
      .catch(() => {
        toastService.warning(strings.OpsSomethingWrongGettingTheData);
      });
  }

  function clickCloseModal() {
    close(orderId);
  }

}

export { ModalNotificationsV2 };